import React from 'react';

import { StyledAvatar } from 'components/avatars';
import styled from 'styled-components';
import { FlexContainer } from 'styles/common';

import { female3IconSrc, female2IconSrc } from 'constants/icons';
import theme from 'constants/theme';

import { Typography4 } from 'uiToolkit/Typography';

const CommentBoxWrapper = styled.div`
  max-width: 70%;
`;

const TextBox = styled.div`
  background: ${(props) => (props.darkBackground ? props.theme.palette.background.lightGrey4 : 'white')};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.palette.borders.lighterGrey};
  display: flex;
  align-items: center;
`;

const CommentRow = ({ text, type = 'manager', bigAvatar = false }) => (
  <FlexContainer style={{ marginBottom: '16px', marginLeft: '8px' }}>
    <StyledAvatar size="fixed32px" src={type === 'manager' ? female2IconSrc : female3IconSrc} />
    <TextBox darkBackground={type === 'manager'} style={{ marginLeft: '16px' }}>
      <Typography4 leftGutter={2} rightGutter={2} topGutter={0.5} bottomGutter={0.5}>
        {text}
      </Typography4>
    </TextBox>
  </FlexContainer>
);

const EnterCommentRow = ({ text }) => (
  <FlexContainer style={{ marginBottom: '24px' }}>
    <StyledAvatar size="fixed40px" src={female2IconSrc} />
    <TextBox darkBackground style={{ marginLeft: '16px', flexGrow: 1 }}>
      <Typography4 leftGutter={2} rightGutter={2} customColor={theme.palette.text.label}>
        {text}
      </Typography4>
    </TextBox>
  </FlexContainer>
);

const CommentPreview = () => (
  <CommentBoxWrapper>
    <EnterCommentRow text="Enter Comment" />
    <CommentRow text="This is a sample manager comment" />
    <CommentRow text="Team member comment" type="reportee" />
    <CommentRow text="Manager and team member can have endless conversation and track progress." />
  </CommentBoxWrapper>
);

export default CommentPreview;
